import { gql } from "lib/apolloClient";
import {
  attachmentFragment,
  studentsAlertFragment,
} from "modules/CommonFragments";

export const getStudentAlertTypesQuery = gql`
  query getStudentAlertTypes($id: ID!) {
    node(id: $id, type: STUDENT) {
      ... on Student {
        id
        alertTypes {
          id
          name
          icon
        }
      }
    }
  }
`;

export const getStudentAlertsQuery = gql`
  query getStudentAlerts(
    $id: ID!
    $first: Int
    $after: String
    $filters: StudentAlertFilters
  ) {
    node(id: $id, type: STUDENT) {
      ... on Student {
        id
        alerts(first: $first, after: $after, filters: $filters) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              title
              description
              createdAt
              attachments {
                ...attachmentItem
              }
              alertType {
                ...alertTypeFields
              }
            }
          }
        }
      }
    }
  }
  ${attachmentFragment.attachment}
  ${studentsAlertFragment}
`;
